<template>
    <section class="section-padding" id="program-lojalnosti-sa-poenima">
        <h2 class="text-center">Program lojalnosti sa poenima</h2>
        <div
            class="container-page d-flex gap-5 flex-column flex-lg-row align-items-center justify-content-between py-4"
        >
            <div class="max-w-sm pt-2 pb-1 py-md-3 py-lg-5">
                <strong class="subtitle d-inline-block mb-3">
                    Žuti, Zeleni i Expert nivo pogodnosti
                </strong>
                <p>
                    U programu sa poenima, pri kupovini naftnih derivata, Lion
                    Expert proizvoda i usluga skupljaš poene direktno u
                    aplikaciji. Jedan poen vredi jedan dinar. Poeni se
                    evidentiraju na tvom nalogu, stanje pratiš u svakom
                    trenutku, a možeš ih iskoristiti kad god želiš.
                    <br /><br />
                    Program ima tri nivoa: Žuti nivo, Zeleni nivo i Expert nivo.
                    Počinješ od Žutog nivoa,
                    <strong>
                        a tvoj nivo u tekućem mesecu zavisi od potrošnje
                        ostvarene u prethodnom mesecu.
                    </strong>
                    Što više koristiš EURO PETROL mrežu u tekućem mesecu, to
                    možeš ostvariti bolje pogodnosti u sledećem. <br /><br />
                    Početni nivo je Žuti. Ukoliko u toku meseca ostvariš
                    potrošnju veću od 9.999 dinara, narednog meseca prelaziš na
                    sledeći nivo - Zeleni. Do najvišeg, Expert nivoa stižeš
                    ukoliko u toku meseca ostvariš kupovinu u vrednosti od
                    20.000 dinara ili više.
                    <br /><br />
                    U obračun mesečne potrošnje koja utiče na nivo, ulaze
                    kupovine goriva i ostalih proizvoda i usluga na Euro Petrol
                    benzinskim stanicama.
                </p>
            </div>
            <div class="d-flex flex-column gap-3">
                <img
                    class="w-speedometer"
                    width="278"
                    height="139"
                    src="/img/application/vector/speedometer-yellow.svg"
                    alt="Žuti Nivo, 0 - 9.999 RSD"
                />
                <img
                    class="w-speedometer"
                    width="278"
                    height="139"
                    src="/img/application/vector/speedometer-green.svg"
                    alt="Zeleni Nivo, 10.000 - 19.999 RSD"
                />
                <img
                    class="w-speedometer"
                    width="278"
                    height="139"
                    src="/img/application/vector/speedometer-gold.svg"
                    alt="Expert Nivo, Preko 20.000 RSD"
                />
            </div>
        </div>
        <div
            class="container-page d-flex gap-5 flex-column flex-lg-row align-items-center justify-content-between py-4"
        >
            <img
                width="466"
                height="537"
                loading="lazy"
                class="img-fluid order-1 order-lg-0 left-image-offset"
                src="/img/application/original/landing-page.webp"
                sizes="(min-width: 768px) 768px, 75vw"
                srcset="
                    /img/application/sm/landing-page.webp    384w,
                    /img/application/lg/landing-page.webp    512w,
                    /img/application/3xl/landing-page.webp   768w,
                    /img/application/5xl/landing-page.webp  1024w,
                    /img/application/7xl/landing-page.webp  1280w,
                    /img/application/8xl/landing-page.webp  1536w,
                    /img/application/9xl/landing-page.webp  1920w,
                    /img/application/10xl/landing-page.webp 2560w
                "
                alt="Početna stranica aplikacije"
            />
            <div class="max-w-sm pt-2 pb-1 py-md-3 py-lg-5">
                <strong class="subtitle d-inline-block mb-3">
                    Gde pratiš ostvarene poene i da li se prenose u naredni
                    mesec?
                </strong>
                <p>
                    Svaki nivo pruža svoje pogodnosti. U okviru aplikacije vidiš
                    pogodnosti trenutnog nivoa i pratiš ostarenje u ovom mesecu,
                    to ostvarenje će definisati koji ćeš nivo biti u narednom
                    mesecu.
                    <br /><br />
                    Na početnom ekranu nalazi se nivo lojalnosti koji si
                    ostvario na osnovu potrošnje u prethodnom mesecu, odnosno tu
                    vidiš trenutni nivo - nivo čije pogodnosti su aktivne i koje
                    koristiš.
                    <strong>
                        Ovaj nivo se ažurira početkom svakog meseca i na osnovu
                        ostvarene potrošnje iz prethodnog meseca, ti se nalaziš
                        na Žutom ili Zelenom ili Expert nivou.
                    </strong>
                    Nivo pogodnosti koje uživaš se u toku meseca ne menjaju.
                    <br /><br />
                    Prikupljeni poeni i poeni koje nisi potrošio se ne
                    anuliraju, nego se zadržavaju i prenose u naredni mesec.
                    Poeni važe do 31. decembra 2028. godine, odnosno anuliraju
                    se 01. januara 2029.
                </p>
            </div>
        </div>
        <div
            class="container-page d-flex gap-5 flex-column flex-lg-row align-items-center justify-content-between"
        >
            <div class="max-w-sm pt-2 pb-1 py-md-3 py-lg-5">
                <strong class="subtitle d-inline-block mb-3">
                    Kazaljka pokazuje koliko si blizu narednog nivoa
                </strong>
                <p>
                    U sekciji „Lojalnost” prikazan je nivo koji pomoću kazaljke
                    pokazuje koliku si potrošnju ostvario u tekućem mesecu. Na
                    osnovu te potrošnje prikazuje se nivo na kom ćeš se nalaziti
                    narednog meseca.
                    <br /><br />
                    Pored toga,
                    <strong>
                        prikazano je i koliko je još novca potrebno da potrošiš
                        da bi prešao na naredni nivo.
                    </strong>
                    Zato se ovaj prikaz može menjati tokom meseca, u zavisnosti
                    od tvoje potrošnje. Važno je da znaš da tokom tekućeg meseca
                    ne koristiš pogodnosti nivoa prikazanog u sekciji
                    „Lojalnost”, već pogodnosti nivoa koji je prikazan na
                    početnom ekranu. <br /><br />
                    Prikaz nivoa u sekciji „Lojalnost” ažurira se svakog meseca.
                    Svakog meseca krećeš od 0 RSD, odnosno od Žutog nivoa, i
                    tokom meseca ostvaruješ potrošnju koja određuje tvoj nivo za
                    naredni mesec.
                </p>
            </div>
            <img
                width="466"
                height="537"
                loading="lazy"
                class="img-fluid right-image-offset"
                src="/img/application/original/loyalty-points-page.webp"
                sizes="(min-width: 768px) 768px, 75vw"
                srcset="
                    /img/application/sm/loyalty-points-page.webp    384w,
                    /img/application/lg/loyalty-points-page.webp    512w,
                    /img/application/3xl/loyalty-points-page.webp   768w,
                    /img/application/5xl/loyalty-points-page.webp  1024w,
                    /img/application/7xl/loyalty-points-page.webp  1280w,
                    /img/application/8xl/loyalty-points-page.webp  1536w,
                    /img/application/9xl/loyalty-points-page.webp  1920w,
                    /img/application/10xl/loyalty-points-page.webp 2560w
                "
                alt="Lojalnost sekcija"
            />
        </div>
        <div class="px-4 px-lg-2 py-5">
            <div class="bordered-box mx-auto text-center max-w-lg py-3 py-lg-4">
                <div class="d-flex flex-column align-items-center gap-2 mb-3">
                    <img
                        class="text-dark"
                        src="/img/application/vector/star.svg"
                    />
                    <strong class="subtitle">Primer kretanja kroz nivoe</strong>
                </div>
                <p>
                    Kazaljka će prikazivati potrošnju u tekućem mesecu, a
                    korisnik će se nalaziti na nivou lojalnosti koji je ostvario
                    u toku prethodnog meseca. Korisnik se automatski po
                    instalaciji aplikacije nalazi u Žutom nivou. U slučaju da je
                    kupac 01.07. instalirao aplikaciju, 05.07. je točio 10.500
                    dinara, kazaljka odmah prelazi na Zeleni nivo. Ukoliko i
                    21.07. natoči 10.500 dinara kazaljka odmah pokazuje da će se
                    u narednom mesecu korisnik nalaziti na Expert nivou. Dakle,
                    kupac će se u sledećem mesecu nalaziti na nivou koji je
                    ostvaren na osnovu potrošnje iz prethodnog meseca.
                </p>
            </div>
        </div>
        <div
            class="container-page d-flex gap-5 flex-column flex-lg-row align-items-center justify-content-between py-5"
        >
            <div class="max-w-md w-100 pt-2 pb-1 py-md-3 py-lg-5">
                <strong class="subtitle d-inline-block mb-3">
                    Kako prikupljaš i trošiš poene pri točenju goriva?
                </strong>
                <p>
                    Poeni u okviru programa lojalnosti se ostvaruju na osnovu
                    prikazane tabele i mogu se sakupljati i trošiti. Takođe
                    moguće je i sakupljanje i trošenje poena na istom računu,
                    odnosno transakciji.
                    <br /><br />
                    Poeni koje sakupljaš po transakciji zavise od nivoa
                    lojalnosti, odnosno -
                    <strong>
                        što se nalaziš na višem nivou, to za
                        gorivo/proizvod/uslugu dobijaš veći broj poena.
                    </strong>
                    <br /><br />
                    Poeni se mogu koristiti u zamenu za dinare. Poeni se mogu
                    trošiti/koristiti za plaćanje goriva i drugih proizvoda i
                    usluga na Euro Petrol benzinskim stanicama. Pri instaliranju
                    aplikacije dobijaš 200 poena.
                </p>
            </div>
            <div class="border rounded-3 overflow-hidden w-100">
                <table class="table table-loyalty mb-0">
                    <thead class="table-light">
                        <tr>
                            <th>
                                <img
                                    src="/img/application/vector/pump.svg"
                                    class="text-dark me-3"
                                />
                                Gorivo
                            </th>
                            <th class="bg-color-secondary text-xl-nowrap">
                                Žuti nivo
                            </th>
                            <th class="bg-color-main text-light text-xl-nowrap">
                                Zeleni nivo
                            </th>
                            <th class="bg-color-gold text-xl-nowrap">
                                Expert nivo
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Evro dizel</td>
                            <td class="text-center">2 p/l</td>
                            <td class="text-center">3 p/l</td>
                            <td class="text-center">4 p/l</td>
                        </tr>
                        <tr>
                            <td>Lion Expert dizel</td>
                            <td class="text-center">10 p/l</td>
                            <td class="text-center">11 p/l</td>
                            <td class="text-center">12 p/l</td>
                        </tr>
                        <tr>
                            <td>Evro premijum BMB 95</td>
                            <td class="text-center">2 p/l</td>
                            <td class="text-center">3 p/l</td>
                            <td class="text-center">4 p/l</td>
                        </tr>
                        <tr>
                            <td>Lion Expert BMB 100</td>
                            <td class="text-center">10 p/l</td>
                            <td class="text-center">11 p/l</td>
                            <td class="text-center">12 p/l</td>
                        </tr>
                        <tr>
                            <td>Autogas TNG</td>
                            <td class="text-center">2 p/l</td>
                            <td class="text-center">3 p/l</td>
                            <td class="text-center">4 p/l</td>
                        </tr>
                        <tr>
                            <td>AdBlue na točenje</td>
                            <td class="text-center">10 p/l</td>
                            <td class="text-center">11 p/l</td>
                            <td class="text-center">12 p/l</td>
                        </tr>
                    </tbody>
                    <tfoot class="table-light">
                        <tr>
                            <td colspan="4" class="text-end">
                                <span class="fw-medium me-4">p = poen</span>
                                <span>1 poen = 1 dinar</span>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <div
            class="container-page d-flex gap-5 flex-column flex-lg-row align-items-center justify-content-between py-5"
        >
            <div
                class="border rounded-3 overflow-hidden w-100 order-1 order-lg-0"
            >
                <table class="table table-loyalty mb-0">
                    <thead class="table-light">
                        <tr>
                            <th class="text-xl-nowrap">
                                <img
                                    src="/img/application/vector/shopping-cart.svg"
                                    class="text-dark me-3"
                                />
                                Proizvod/usluga
                            </th>
                            <th class="bg-color-secondary text-xl-nowrap">
                                Žuti nivo
                            </th>
                            <th class="bg-color-main text-light text-xl-nowrap">
                                Zeleni nivo
                            </th>
                            <th class="bg-color-gold text-xl-nowrap">
                                Expert nivo
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Proizvodi iz prodavnice i restorana</td>
                            <td class="text-center">3%</td>
                            <td class="text-center">5%</td>
                            <td class="text-center">7%</td>
                        </tr>
                        <tr>
                            <td>Lion Expert PL robna marka</td>
                            <td class="text-center">10%</td>
                            <td class="text-center">10%</td>
                            <td class="text-center">10%</td>
                        </tr>
                        <tr>
                            <td>Kafe (sve vrste)</td>
                            <td class="text-center">15%</td>
                            <td class="text-center">15%</td>
                            <td class="text-center">15%</td>
                        </tr>
                        <tr>
                            <td>Žetoni za pranje</td>
                            <td class="text-center">15%</td>
                            <td class="text-center">15%</td>
                            <td class="text-center">15%</td>
                        </tr>
                        <tr>
                            <td>Butan boce</td>
                            <td class="text-center">5p/kg</td>
                            <td class="text-center">6p/kg</td>
                            <td class="text-center">7p/kg</td>
                        </tr>
                    </tbody>
                    <tfoot class="table-light">
                        <tr>
                            <td colspan="4">
                                <span class="fw-medium me-4">p = poen</span>
                                <span
                                    >*iznosi poena moraju biti promenljivi
                                    shodno promenama na tržištu</span
                                >
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="max-w-md w-100 pt-2 pb-1 py-md-3 py-lg-5">
                <strong class="subtitle d-inline-block mb-3">
                    Kako sakupljaš poene pri kupovini proizvoda i usluga?
                </strong>
                <p>
                    Za svaku kupovinu ostalih proizvoda i usluga na osnovu nivoa
                    na kom se nalaziš, ostvaruješ procenat (%) poena naveden u
                    tabeli, u odnosu na cenu artikla/usluge.
                    <br /><br />
                    Na primer izvršena je kupovina proizvoda iz prodavnice i
                    restorana u ukupnom iznosu od 2.650 RSD, broj poena koji se
                    dobija po ovom osnovu je na Žutom nivou 80 bodova, na
                    Zelenom nivou 133 boda, na Expert nivou 186 bodova.
                    <br /><br />
                    Ukoliko u okviru jednog računa imaš na primer i proizvode iz
                    restorana i prodavnice i Lion Expert robnu marku onda se u
                    okviru računa obračunavaju, odnosno ostvaruju, poeni u
                    skladu sa tabelom, odnosno u Zelenom nivou će se za
                    proizvode iz prodavnice i restorana ostvarivati 5%, dok će
                    se za Lion Expert robnu marku ostvarivati 10%.
                    <strong>
                        Broj poena se može iskoristiti isključivo u celosti.
                    </strong>
                </p>
            </div>
        </div>
        <div class="px-4 px-lg-2 py-5">
            <div class="bordered-box mx-auto text-center max-w-lg py-3 py-lg-4">
                <div class="d-flex flex-column align-items-center gap-2 mb-3">
                    <img
                        class="text-dark"
                        src="/img/application/vector/star.svg"
                    />
                    <strong class="subtitle"
                        >Primer prikupljanja i trošenja poena</strong
                    >
                </div>
                <p>
                    Račun korisnika na kasi iznosi 2.700 RSD. Korisnik prilikom
                    plaćanja prikazuje svoj personalizovani QR kod iz
                    aplikacije, koji kasir skenira. Kasir pita korisnika da li
                    želi da iskoristi poene. Korisnik u aplikaciji trenutno ima
                    300 poena i potvrđuje da želi da ih iskoristi za ovu
                    kupovinu. Kako 1 poen vredi 1 RSD, iznos računa se umanjuje
                    za 300 RSD. Nakon iskorišćenih poena, korisnik plaća 2.400
                    RSD. Po završetku kupovine, iskorišćeni poeni se oduzimaju u
                    aplikaciji, a novi poeni se dodaju/obračunavaju na osnovu
                    završene transakcije u zavisnosti od kupljenih
                    proizvoda/usluga i nivoa lojalnosti na kom se korisnik
                    nalazi.
                </p>
            </div>
        </div>
    </section>
</template>

<style scoped>
.w-speedometer {
    width: 17rem;
    height: auto;
}

.table-loyalty td,
.table-loyalty th {
    vertical-align: middle;
    border: none !important;
}

.table-loyalty th {
    text-align: center;
    padding: 1rem 1.5rem !important;
}

.table-loyalty td {
    padding: 0.875rem 1.5rem;
}

.table-loyalty tfoot {
    font-size: 0.875rem;
}

@media (min-width: 1024px) and (max-width: 1440px) {
    .left-image-offset {
        margin-left: -5rem;
    }

    .right-image-offset {
        margin-right: -5rem;
    }
}

@media (max-width: 1280px) {
    .table-loyalty th {
        padding: 0.5rem !important;
    }

    .table-loyalty td {
        padding: 0.625rem 0.75rem !important;
    }

    .table-loyalty td,
    .table-loyalty th {
        font-size: 0.875rem;
    }
}
</style>
